var collapsible_list_component_rtlignore_default = {
  "ltr": "apJX8",
  "rtl": "EY6bz",
  "iconContainer": "gOWHg",
  "icon": "WxZIm",
  "isExpanded": "G8Fos",
  "listDimensions": "mEmAC"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
